import { PROJECT_CHARTER_API_CONSTANTS } from './api-constants/project-charter-payload-constants';
import { CODE_EDITOR_API_CONSTANTS } from './api-constants/code-editor-constants';
import { COMPANION_API_CONSTANTS } from './api-constants/companion-payload-constant';
import { ENVIRONMENT_AVAILABILITY_API_CONSTANTS } from './api-constants/environment-availability-constants';
import { PREVIEW_API_CONSTANTS } from './api-constants/preview-constants';

export class ApiConstants {
  public static readonly authenticateUser = {
    method: 'get',
    url: 'appuserprivileges/authenticate'
  };

  public static readonly ssoAuthenticateUser = {
    method: 'get',
    url: 'appuserprivileges/sso/authenticate'
  };

  /* payload useremail */
  public static readonly getOTP = {
    method: 'post',
    url: 'otp/generateandsendotp'
  };

  public static readonly deleteReferenceBySid = {
    method: 'delete',
    url: 'modelreferences/delete/referenceBySid/{sid}'
  };

  /* username: email, otp: otp as formparam */
  public static readonly loginUser = {
    method: 'post',
    url: 'login/otp'
  };

  public static readonly logoutUser = {
    method: 'get',
    url: 'logout'
  };

  public static readonly getSidebarData = {
    method: 'get',
    url: 'assets/configData/sidebar.json'
  };

  public static readonly getAllTables = {
    method: 'get',
    url: 'applicationdatamodels/pageinfo/noncompositelist',
    withAppIdInUrl: true
  };

  public static readonly getAllWorkFlowTables = {
    method: 'get',
    url: 'applicationdatamodels/workflow/tablelist',
    withAppIdInUrl: true
  };

  public static readonly createScreen = {
    method: 'post',
    url: 'screens/generatecustom/'
  };

  public static readonly addScreensForTables = {
    method: 'post',
    url: 'screens/generatedefault',
    withAppIdInUrl: true
  };

  public static readonly migrateSearchable = {
    method: 'post',
    url: 'appsettings/searchableProperty'
  };

  public static readonly getAllScreens = {
    method: 'get',
    url: 'screens/all',
    withAppIdInUrl: true
  };

  public static readonly getScreensForMemAndSuiteApp = {
    method: 'get',
    url: 'apps/getmsappspages/{suiteId}'
  };

  public static readonly getScrById = {
    method: 'get',
    url: 'screens/sid/{sid}/{appid}',
    withAppIdInUrl: true
  };

  public static readonly updateScreen = {
    method: 'put',
    url: 'screens'
  };

  public static readonly deleteScreens = {
    method: 'delete',
    url: 'screens/{id}',
    withAppIdInUrl: true
  };

  public static readonly landingScreen = {
    method: 'get',
    url: 'screens/markaslanding'
  };

  public static readonly updateTableData = {
    method: 'put',
    url: 'applicationdatamodels/updatefields'
  };

  public static readonly getDatamodelProperties = {
    method: 'get',
    url: 'properties/load/datamodel.properties',
    withAppIdInUrl: true
  };

  public static readonly saveDatamodelTreeOrder = {
    method: 'post',
    url: 'datamodelorderinginfos'
  };
  public static readonly updateDatamodelTreeOrder = {
    method: 'put',
    url: 'datamodelorderinginfos'
  };

  public static readonly getDatamodelTreeOrder = {
    method: 'get',
    url: 'applicationdatamodels/all',
    withAppIdInUrl: true
  };

  public static readonly getLookUpTables = {
    method: 'get',
    url: 'applicationdatamodels/suite/lookuptables',
    withAppIdInUrl: true
  };

  public static readonly saveInitialDatamodelOrder = {
    method: 'post',
    url: 'tables/create/batch',
    withAppIdInUrl: true
  };

  public static readonly getDatamodelOrder = {
    method: 'get',
    url: 'datamodelorderinginfos/{tableId}',
    withAppIdInUrl: true
  };

  public static readonly saveDatamodelOrderOnCollapse = {
    method: 'POST',
    url: 'datamodelorderinginfos/addfieldorgroup/{tableid}',
    withAppIdInUrl: true
  };

  public static readonly saveTable = {
    method: 'post',
    url: 'tables'
  };

  public static readonly updateTable = {
    method: 'put',
    url: 'tables'
  };

  public static readonly saveBatch = {
    method: 'post',
    url: 'applicationdatamodels/batch',
    withAppIdInUrl: true
  };

  public static readonly saveTableBatch = {
    method: 'post',
    url: 'tables/batch',
    withAppIdInUrl: true
  };

  public static readonly deleteTable = {
    method: 'delete',
    url: 'tables/{sid}',
    withAppIdInUrl: true
  };

  public static readonly getDatamodelData = {
    method: 'get',
    url: 'assets/properties/datamodel_common.json'
  };

  public static readonly getDatamodelTableData = {
    method: 'get',
    url: 'applicationdatamodels/get/sid/{sid}'
  };

  public static readonly getTableValidationData = {
    method: 'get',
    url: 'applicationdatamodels/validation/{sid}' // Supports ignoreWarnings query parameter
  };
  // App management
  public static readonly getAppsListData = {
    method: 'post',
    url: 'apps/apps/datatable',
    withOrgIdInUrl: true
  };

  public static readonly getAppsListForOrg = {
    method: 'post',
    url: 'apps/apps/datatable/'
  };

  public static readonly getAppsListForDropdown = {
    method: 'post',
    url: 'apps/apps/dropdown/datatable/'
  };

  public static readonly getOrgData = {
    method: 'post',
    url: 'organizations/organizations/datatable'
  };

  public static readonly getBranchingStatusData = {
    method: 'get',
    url: 'apps/refs/branchingStatus/{appId}'
  };

  public static readonly getAppById = {
    method: 'get',
    url: 'apps/sid/'
  };
  public static readonly getAppWithOutMenu = {
    method: 'get',
    url: 'apps/appWithoutMenu/'
  };
  public static readonly saveAppData = {
    method: 'post',
    url: 'apps'
  };

  public static readonly updateAppById = {
    method: 'put',
    url: 'apps'
  };

  public static readonly copyApp = {
    method: 'post',
    url: 'appcopy/copy'
  };

  public static readonly deleteAppData = {
    method: 'delete',
    url: 'apps/'
  };

  public static readonly checkUnpublishedChanges = {
    method: 'get',
    url: 'modelevent/checkForUnPublishedChanges/{appId}'
  };

  // User management
  public static readonly saveUserData = {
    method: 'post',
    url: 'appuserprivileges/appuserprivileges/datatable'
  };

  public static readonly getUsersListData = {
    method: 'post',
    url: 'appuserprivileges/appuserprivileges/datatable'
  };

  public static readonly getAppNavigationStructure = {
    method: 'get',
    url: 'properties/load/list/appnavigation.structure',
    withAppIdInUrl: true
  };

  public static readonly getAppNavigationProperties = {
    method: 'get',
    url: 'properties/load/modeller',
    withAppIdInUrl: true
  };

  public static readonly getDocumentBasedOnId = {
    method: 'get',
    url: 'appdocuments/sid/',
    withAppIdInUrl: true
  };

  public static readonly getDocumentsData = {
    method: 'post',
    url: 'appdocuments/appdocuments/datatable',
    withAppIdInUrl: true
  };
  public static readonly getFilesDataWithSearch = {
    method: 'post',
    url: 'attachmentorderinginfos/search',
    withAppIdInUrl: true
  };

  // Add New Document
  public static readonly saveDocument = {
    method: 'post',
    url: 'appdocuments/'
  };

  // Updated Existing Document
  public static readonly updateDocument = {
    method: 'put',
    url: 'appdocuments/'
  };

  // Delete An Document
  public static readonly deleteDocument = {
    method: 'delete',
    url: 'appdocuments/',
    withAppIdInUrl: true
  };

  // Updated File Content appdocuments
  public static readonly updateFileContentsDocument = {
    method: 'put',
    url: 'appdocuments/filecontent/',
    withAppIdInUrl: true
  };

  public static readonly deleteAtatchment = {
    method: 'delete',
    url: 'appdocuments/attachment/',
    withAppIdInUrl: false
  };

  // Get File Contents
  public static readonly getFileContents = {
    method: 'get',
    url: 'attachments/download/attachment/'
  };

  public static readonly getFileAttachmentsDataOrder = {
    method: 'get',
    url: 'appfileattachments/app',
    withAppIdInUrl: true
  };

  public static readonly getFileAttachmentsDataOrderWithSorting = {
    method: 'get',
    url: 'appfileattachments/sort/app/{appid}/{field}/{direction}'
  };

  public static readonly saveFileAttachmentsDataOrder = {
    method: 'post',
    url: 'appfileattachments'
  };

  public static readonly updateFileAttachmentsDataOrder = {
    method: 'put',
    url: 'appfileattachments'
  };

  public static readonly deleteFileAttachmentsDataOrder = {
    method: 'delete',
    url: 'appfileattachments/attachment/'
  };

  // Get Organization Data
  public static readonly getOrganizationData = {
    method: 'post',
    url: 'organizations/organizations/datatable'
    // withOrgIdInUrl: true,
  };

  // Get Organization Data
  public static readonly getOrganizationById = {
    method: 'get',
    url: 'organizations/sid/'
  };

  // Save Organization Data
  public static readonly saveOrganization = {
    method: 'post',
    url: 'organizations/'
  };

  // Update Organization Data
  public static readonly updateOrganization = {
    method: 'put',
    url: 'organizations/'
  };

  // Store Git token
  public static readonly storeGitToken = {
    method: 'post',
    url: 'organizations/store-git-token'
  };

  // Delete Organization Data
  public static readonly deleteOrganization = {
    method: 'delete',
    url: 'organizations/'
  };

  public static readonly deactivateOrganization = {
    method: 'put',
    url: 'organizations/deactivate'
  };

  public static readonly activateOrgnization = {
    method: 'put',
    url: 'organizations/activate'
  };

  // Get Users Data
  public static readonly getUsers = {
    method: 'post',
    url: 'appuserprivileges/appuserprivileges/datatable',
    withOrgIdInUrl: true
  };
  // Get Users Data
  public static readonly getUsersForSearch = {
    method: 'post',
    url: 'appuserprivileges/search/datatable/org',
    withOrgIdInUrl: true
  };
  // Get User By Organization
  public static readonly getUserById = {
    method: 'get',
    url: 'appuserprivileges/sid/',
    withOrgIdInUrl: true
  };
  public static readonly getAppForUser = {
    method: 'get',
    url: 'apps/getAppsSharedWithUser/{email}/{orgid}'
  };

  // Get User By Email
  public static readonly getUserByEmail = {
    method: 'get',
    url: 'appuserprivileges/getUserByEmail/',
    withOrgIdInUrl: true
  };

  // Get User By Organization
  public static readonly delUserInApp = {
    method: 'delete',
    url: 'apps/delete/{email}/{appid}/{orgid}'
  };

  // Test git connection
  public static readonly testGitConnection = {
    method: 'post',
    url: 'git/testConnection'
  };

  // Save User Data
  public static readonly saveUser = {
    method: 'post',
    url: 'appuserprivileges/'
  };

  // Update User Data
  public static readonly updateUser = {
    method: 'put',
    url: 'appuserprivileges/'
  };

  // Delete User Data
  public static readonly deleteUser = {
    method: 'delete',
    url: 'appuserprivileges/',
    withOrgIdInUrl: true
  };

  public static readonly shareApp = {
    method: 'post',
    url: 'apps/sharedWith/{appid}/{orgid}/{email}/{role}'
  };

  public static readonly setDefaultBranch = {
    method: 'put',
    url: 'apps/branches/set-default'
  };

  public static readonly getEnvironmentWithDb = {
    method: 'get',
    url: '/environments/environments/appid/{appid}/shareddb/{shareddb}'
  };
  // Delete User Data
  public static readonly sendFileAttachment = {
    method: 'post',
    url: 'attachments/upload/3ff2a39b-78fc-423b-8924-11c9b796af80/07637158-9641-445e-b9f3-3f2f7e16de50',
    // url: 'attachments/upload/3ff2a39b-78fc-423b-8924-11c9b796af80',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    withOrgIdInUrl: true,
    withAppIdInUrl: true
  };

  public static readonly getMomData = {
    method: 'get',
    url: 'apps/sid/'
  };

  public static readonly getScreensContent = {
    method: 'get',
    url: 'attachments/download/attachment/{sid}/{appId}',
    withAppIdInUrl: true
  };

  public static readonly updateScreensContent = {
    method: 'put',
    url: 'screens/filecontent',
    withAppIdInUrl: true
  };

  public static readonly getRolesData = {
    method: 'post',
    url: 'roles/roles/datatable',
    withAppIdInUrl: true
  };
  public static readonly updateTableRoles = {
    method: 'post',
    url: 'applicationdatamodels/table/update/roles',
    withAppIdInUrl: false
  };

  public static readonly updateTableFieldAccess = {
    method: 'post',
    url: 'applicationdatamodels/field/update/access',
    withAppIdInUrl: false
  };

  public static readonly getAppRolesData = {
    method: 'post',
    url: 'roles/roles/datatable'
  };

  public static readonly getRolesDataBySid = {
    method: 'get',
    url: 'roles/role/getById/'
  };
  public static readonly getRolesDataWithSorting = {
    method: 'post',
    url: 'roles/roles/datatable/{appid}/{field}/{direction}',
    withAppIdSortInUrl: true
  };

  public static readonly getAllRolesByAppId = {
    method: 'get',
    url: 'roles/roles/all',
    withAppIdInUrl: true
  };

  public static readonly saveRoleData = {
    method: 'post',
    url: 'roles'
  };

  public static readonly updateRoleData = {
    method: 'put',
    url: 'roles'
  };

  public static readonly deleteRoleData = {
    method: 'delete',
    url: 'roles/',
    withAppIdInUrl: true
  };

  public static readonly bulkUpdateRoles = {
    method: 'post',
    url: 'roles/access/bulk/update'
  };

  public static readonly getAllServices = {
    method: 'post',
    url: 'services/services/datatable',
    withAppIdInUrl: true
  };

  public static readonly getAllServicesByAppId = {
    method: 'get',
    url: 'services/services',
    withAppIdInUrl: true
  };

  public static readonly getServicesFrmDataTbl = {
    method: 'get',
    url: 'services/datatable'
  };

  public static readonly getServicesByTblId = {
    method: 'get',
    url: 'services/services'
  };

  public static readonly saveServiceData = {
    method: 'post',
    url: 'services'
  };

  public static readonly updateServiceData = {
    method: 'put',
    url: 'services'
  };

  public static readonly deleteServices = {
    method: 'delete',
    url: 'services/{serviceIds}',
    withAppIdInUrl: true
  };

  public static readonly generateScript = {
    method: 'post',
    url: 'tables/rdbms/generatescript/{appid}'
  };

  public static readonly getServicesCount = {
    method: 'get',
    url: 'services/services/count',
    withAppIdInUrl: true
  };

  public static readonly updateServiceACL = {
    method: 'post',
    url: 'services/update/roles'
  };

  public static readonly getFieldInfoFromTable = {
    method: 'get',
    url: 'datamodelconfigured/config/table/{tableId}/{screenId}',
    withAppIdInUrl: true
  };
  public static readonly getFieldForPages = {
    method: 'get',
    url: 'datamodelconfigured/config/table/'
  };
  public static readonly getFieldInfo = {
    method: 'get',
    url: 'applicationdatamodels/fields/all/{tableId}'
  };
  public static readonly getFields = {
    method: 'get',
    url: 'applicationdatamodels/fields/all/'
    // withAppIdInUrl: true
  };
  public static readonly updateFieldInfoFromTable = {
    method: 'put',
    url: 'datamodelconfigured'
  };

  public static readonly updateScreenAndDMCOnfig = {
    method: 'put',
    url: 'screens/updatecontent',
    withAppIdInUrl: true
  };

  public static readonly updateMenuTileACL = {
    method: 'put',
    url: 'screens/roles/tilesAndMenu'
  };

  public static readonly getChildTablesByParentTableId = {
    method: 'get',
    url: 'applicationdatamodels/childtables/{tableId}',
    withAppIdInUrl: true
  };

  public static readonly getUserStoriesOrder = {
    method: 'get',
    url: 'userstoryorderinginfos/app',
    withAppIdInUrl: true
  };
  public static readonly getUserStoriesOrderWithSorting = {
    method: 'get',
    url: 'userstoryorderinginfos/sort/{appid}/{field}/{direction}'
  };
  public static readonly saveUserStoriesOrder = {
    method: 'post',
    url: 'userstoryorderinginfos'
  };
  public static readonly updateUserStoriesOrder = {
    method: 'put',
    url: 'userstoryorderinginfos'
  };
  public static readonly getUserStoriesData = {
    method: 'post',
    url: 'userstories/userstories/datatable',
    withAppIdInUrl: true
  };

  public static readonly saveUserStoriesData = {
    method: 'post',
    url: 'userstories'
  };

  public static readonly updateUserStoriesData = {
    method: 'put',
    url: 'userstories'
  };

  public static readonly deleteUserStoriesData = {
    method: 'delete',
    url: 'userstories/{ids}',
    withAppIdInUrl: true
  };

  public static readonly deleteFileAttachment = {
    method: 'delete',
    url: 'userstories/attachment/'
  };

  public static readonly getTechnologyStackById = {
    method: 'get',
    url: 'technologystacks/app/'
  };

  public static readonly getTechnologyStackBySuiteId = {
    method: 'get',
    url: 'technologystacks/suite/suiteid/{suiteid}/shareddbid/{shareddbid}'
  };

  public static readonly getMemberApps = {
    method: 'get',
    url: 'apps/getmemberapps/suiteid/{suiteId}/shareddbid/{sharedDbId}'
  };

  public static readonly getEnvironmentsBySuiteId = {
    method: 'get',
    url: 'environments/suite/datatable'
  };

  public static readonly getTechnologyStackByAppId = {
    method: 'get',
    url: 'technologystacks/app/{appId}'
  };

  public static readonly saveTechnologyStack = {
    method: 'post',
    url: 'technologystacks/'
  };

  public static readonly updateTechnologyStack = {
    method: 'put',
    url: 'technologystacks/'
  };

  public static readonly deleteTechnologyStack = {
    method: 'delete',
    url: 'technologystacks/',
    withAppIdInUrl: true
  };
  //App settings
  public static readonly getSettingsById = {
    method: 'get',
    url: 'appsettings/app/'
  };

  public static readonly saveAppSettings = {
    method: 'post',
    url: 'appsettings/'
  };

  public static readonly updateAppSettings = {
    method: 'put',
    url: 'appsettings/'
  };
  public static readonly enablesoftdelete = {
    method: 'post',
    url: 'appsettings/enableSoftDelete/{appId}'
  };
  public static readonly deleteAppSettings = {
    method: 'delete',
    url: 'technologystacks/',
    withAppIdInUrl: true
  };
  //Environment
  public static readonly getAllEnvironment = {
    method: 'post',
    url: 'environments/environments/datatable/'
  };

  public static readonly saveEnvironment = {
    method: 'post',
    url: 'environments/'
  };

  public static readonly updateEnvironment = {
    method: 'put',
    url: 'environments/'
  };

  public static readonly deleteEnvironment = {
    method: 'delete',
    url: 'environments/',
    withAppIdInUrl: true
  };
  public static readonly uploadEnvironmentAttachment = {
    method: 'post',
    url: 'environments/attachment/upload'
  };

  public static readonly deleteEnvironmentAttachment = {
    method: 'delete',
    url: 'environments/attachment/{sid}'
  };

  public static readonly getPrototypeSampleData = {
    method: 'get',
    url: 'prototypingdata/app',
    withAppIdInUrl: true
  };

  public static readonly getGenerateAllSampleData = {
    method: 'get',
    url: 'prototypingdata/generateall',
    withAppIdInUrl: true
  };

  public static readonly upDateSampleData = {
    method: 'put',
    url: 'prototypingdata'
  };

  public static readonly getTemplates = {
    method: 'post',
    url: 'templates/templates/datatable',
    withAppIdInUrl: true
  };
  public static readonly getTemplateData = {
    method: 'get',
    url: 'templates/sid/{sid}',
    withAppIdInUrl: true
  };
  public static readonly getTemplatesProperties = {
    method: 'get',
    url: 'properties/load/modeller',
    withAppIdInUrl: true
  };
  public static readonly saveTemplates = {
    method: 'post',
    url: 'templates/'
  };
  public static readonly updateTemplates = {
    method: 'put',
    url: 'templates/update',
    withAppIdInUrl: true
  };
  public static readonly changeDefaultTemplate = {
    method: 'put',
    url: 'templates/markasdefault'
  };
  public static readonly getLanguages = {
    method: 'get',
    url: 'applanguages/app',
    withAppIdInUrl: true
  };
  public static readonly saveLanguage = {
    method: 'post',
    url: 'applanguages'
  };
  public static readonly updateLanguage = {
    method: 'put',
    url: 'applanguages'
  };
  public static readonly getTranslations = {
    method: 'get',
    url: 'translations/app',
    withAppIdInUrl: true
  };
  public static readonly generateTranslations = {
    method: 'get',
    url: 'translations/generate',
    withAppIdInUrl: true
  };
  public static readonly updateTranslations = {
    method: 'put',
    url: 'translations'
  };
  public static readonly getAllTablesByType = {
    method: 'get',
    url: '/tables/tables/{appid}/{type}'
  };
  public static readonly getCustomComponent = {
    method: 'get',
    url: 'customcomponents/sid/',
    withAppIdInUrl: true
  };
  public static readonly saveCustomComponent = {
    method: 'post',
    url: 'customcomponents'
  };
  public static readonly updateCustomComponent = {
    method: 'put',
    url: 'customcomponents'
  };
  public static readonly getAllCustomComponents = {
    method: 'post',
    url: 'customcomponents/customcomponents/datatable',
    withAppIdInUrl: true
  };

  public static readonly deleteCustomComponent = {
    method: 'delete',
    url: 'customcomponents/',
    withAppIdInUrl: true
  };
  public static readonly getApplicationDataModelMetaInfo = {
    method: 'get',
    url: 'applicationdatamodels/mappinginfo',
    withAppIdInUrl: true
  };

  public static readonly getAppMetaInfosByAppID = {
    method: 'get',
    url: 'appmetainfos/get/{appId}'
  };

  /* App and Page generation services */

  public static readonly createApp = {
    method: 'post',
    url: 'generator/{appId}/project/create'
  };

  public static readonly getExposedAPI = {
    method: 'get',
    url: 'exposedAPIInfo/app',
    withAppIdInUrl: true
  };
  public static readonly getExposedAPIByComponentId = {
    method: 'get',
    url: 'exposedAPIInfo/app/{appid}/{functionalcompid}'
  };
  public static readonly getExposedApiAutosuggest = {
    method: 'get',
    url: 'exposedAPIInfo/autosuggest/app/'
  };
  public static readonly getExposedAPIByClientId = {
    method: 'get',
    url: 'exposedAPIInfo/{clientId}/{appId}'
  };
  public static readonly saveExposedAPI = {
    method: 'post',
    url: 'exposedAPIInfo'
  };
  public static readonly saveExposedAPIBatch = {
    method: 'post',
    url: 'exposedAPIInfo/batch'
  };
  public static readonly updateExposedAPI = {
    method: 'put',
    url: 'exposedAPIInfo'
  };
  public static readonly deleteExposedAPI = {
    method: 'delete',
    url: 'exposedAPIInfo/{ids}',
    withAppIdInUrl: true
  };

  public static readonly getExposedClient = {
    method: 'get',
    url: 'client/app',
    withAppIdInUrl: true
  };
  public static readonly getExposedClientAutosuggest = {
    method: 'get',
    url: 'client/autosuggest/app/'
  };
  public static readonly saveExposedClient = {
    method: 'post',
    url: 'client'
  };
  public static readonly updateExposedClient = {
    method: 'put',
    url: 'client'
  };
  public static readonly deleteExposedClient = {
    method: 'delete',
    url: 'client/{ids}',
    withAppIdInUrl: true
  };
  public static readonly getExposedComponent = {
    method: 'get',
    url: 'functionalComponent/app',
    withAppIdInUrl: true
  };
  public static readonly getExposedComponentAutosuggest = {
    method: 'get',
    url: 'functionalComponent/autosuggest/app/'
  };
  public static readonly getExposedComponentByClientId = {
    method: 'get',
    url: 'functionalComponent/app/{appid}/{clientid}'
  };
  public static readonly saveExposedComponent = {
    method: 'post',
    url: 'functionalComponent'
  };
  public static readonly updateExposedComponent = {
    method: 'put',
    url: 'functionalComponent'
  };
  public static readonly deleteExposedComponent = {
    method: 'delete',
    url: 'functionalComponent/{ids}',
    withAppIdInUrl: true
  };
  public static readonly getConsumedComponent = {
    method: 'get',
    url: 'apigroup/app',
    withAppIdInUrl: true
  };
  public static readonly getConsumedComponentAutosuggest = {
    method: 'get',
    url: 'apigroup/autosuggest/app/'
  };
  public static readonly getConsumedComponentByProviderId = {
    method: 'get',
    url: 'apigroup/app/{appId}/{providerId}'
  };
  public static readonly saveConsumedComponent = {
    method: 'post',
    url: 'apigroup'
  };
  public static readonly updateConsumedComponent = {
    method: 'put',
    url: 'apigroup'
  };
  public static readonly deleteConsumedComponent = {
    method: 'delete',
    url: 'apigroup/{ids}',
    withAppIdInUrl: true
  };
  public static readonly getConsumedProviders = {
    method: 'get',
    url: 'providerinformation/app',
    withAppIdInUrl: true
  };
  public static readonly getConsumedProviderAutosuggest = {
    method: 'get',
    url: 'providerinformation/autosuggest/app/'
  };
  public static readonly saveConsumedProvider = {
    method: 'post',
    url: 'providerinformation'
  };
  public static readonly updateConsumedProvider = {
    method: 'put',
    url: 'providerinformation'
  };
  public static readonly deleteConsumedProvider = {
    method: 'delete',
    url: 'providerinformation/{ids}',
    withAppIdInUrl: true
  };
  public static readonly getConsumedAPIs = {
    method: 'get',
    url: 'apiinfo/app',
    withAppIdInUrl: true
  };
  public static readonly saveConsumedAPI = {
    method: 'post',
    url: 'apiinfo'
  };
  public static readonly updateConsumedAPI = {
    method: 'put',
    url: 'apiinfo'
  };
  public static readonly deleteConsumedAPI = {
    method: 'delete',
    url: 'apiinfo/{ids}',
    withAppIdInUrl: true
  };
  public static readonly getConsumedApiAutosuggest = {
    method: 'get',
    url: 'apiinfo/autosuggest/app/'
  };
  public static readonly getConsumedAPIByComponentId = {
    method: 'get',
    url: 'apiinfo/appid/{appId}/apigroupid/{apigroupId}'
  };
  public static readonly getConsumedAPIByProviderId = {
    method: 'get',
    url: 'apiinfo/appid/{appId}/providerid/{providerId}'
  };
  public static readonly getIntegrationOrder = {
    method: 'get',
    url: 'integrationorderinginfo/app',
    withAppIdInUrl: true
  };
  public static readonly saveIntegrationOrder = {
    method: 'post',
    url: 'integrationorderinginfo'
  };
  public static readonly updateIntegrationOrder = {
    method: 'put',
    url: 'integrationorderinginfo'
  };
  public static readonly getExposedRestOrder = {
    method: 'get',
    url: 'exposedrestapiorderinginfo/app',
    withAppIdInUrl: true
  };
  public static readonly saveExposedRestOrder = {
    method: 'post',
    url: 'exposedrestapiorderinginfo'
  };
  public static readonly updateExposedRestOrder = {
    method: 'put',
    url: 'exposedrestapiorderinginfo'
  };
  public static readonly getIntegrationProperties = {
    method: 'get',
    url: 'properties/load/integration.properties',
    withAppIdInUrl: true
  };
  public static readonly getEnvironments = {
    method: 'post',
    url: 'environments/datatable',
    withAppIdInUrl: true
  };
  public static readonly getConfigKeys = {
    method: 'get',
    url: 'configurationkeys/app',
    withAppIdInUrl: true
  };
  public static readonly saveConfigKeys = {
    method: 'post',
    url: 'configurationkeys'
  };
  public static readonly updateConfigKeys = {
    method: 'put',
    url: 'configurationkeys'
  };
  public static readonly deleteConfigKeys = {
    method: 'delete',
    url: 'configurationkeys/{appconfigkeysId}',
    withAppIdInUrl: true
  };

  public static readonly getAppNames: any = {
    url: 'error/appNames',
    method: 'GET',
    showloading: true
  };

  public static readonly getGenerationDetails: any = {
    url: 'error/generationdetails/{appName}',
    method: 'GET',
    showloading: true
  };
  public static readonly getClassDiagram: any = {
    url: 'datamodel/getClassDiagram/{appName}',
    method: 'GET',
    showloading: true
  };

  public static readonly getCustomComponentsForApp = {
    method: 'get',
    url: 'customcomponents/basic',
    withAppIdInUrl: true
  };

  public static readonly getTableAclBySid: any = {
    method: 'get',
    url: 'tablefieldacls/table/{tableid}',
    withAppIdInUrl: true
  };

  public static readonly saveTableAcl = {
    method: 'post',
    url: 'tablefieldacls'
  };

  public static readonly saveBatchTableAcl = {
    method: 'post',
    url: 'tablefieldacls/saveBatch'
  };

  public static readonly updateTableAcl = {
    method: 'put',
    url: 'tablefieldacls'
  };

  public static readonly updateBatchTableAcl = {
    method: 'put',
    url: 'tablefieldacls/table/saveBatch'
  };

  public static readonly cloneColumnLevelPermissions = {
    method: 'put',
    url: 'tablefieldacls/clonePermissionsColumnLevel'
  };

  public static readonly deleteTableAcl = {
    method: 'delete',
    url: 'tablefieldacls/{ids}',
    withAppIdInUrl: true
  };

  public static readonly getGenStatus = {
    method: 'get',
    url: 'generationlogs/latestmodified',
    withAppIdInUrl: true
  };

  public static readonly getGenerationHistory = {
    method: 'get',
    url: 'generationlogs/history',
    withAppIdInUrl: true
  };

  public static readonly getSchemaEventLogHistory = {
    method: 'get',
    url: 'schemaeventlog/history',
    withAppIdInUrl: true
  };

  public static readonly getModelEventsByGenerationLog = {
    method: 'get',
    url: 'modelevent/bygenerationlog/{generationLogId}',
    withAppIdInUrl: true
  };

  public static readonly getSchemaEventsByGenerationLog = {
    method: 'post',
    url: 'schemaevents/byschemaeventlog/{appId}/{schemaEventLogId}'
  };

  public static readonly saveGenerationConfig = {
    method: 'put',
    url: 'generationlogs/{sid}/config',
    withAppIdInUrl: true
  };

  public static readonly saveSchemaEventLog = {
    method: 'put',
    url: 'schemaeventlog'
  };

  public static readonly getGenerationConfig = {
    method: 'get',
    url: 'generationlogs/{sid}/config',
    withAppIdInUrl: true
  };

  public static readonly updateSchemaEventLogRemarks = {
    method: 'put',
    url: 'schemaeventlog/{sid}/remarks',
    withAppIdInUrl: true
  };

  public static readonly markGenerationDeployed = {
    method: 'put',
    url: 'generationlogs/{sid}/deployed',
    withAppIdInUrl: true
  };

  public static readonly getDeltaSqlBySchemaEventLog = {
    method: 'post',
    url: 'codegenerator/generatedeltasql/{appId}/{schemaEventLogId}',
    responseType: 'text'
  };

  public static readonly genBECodeApi = {
    method: 'post',
    url: 'generator/{appId}/backend/generate'
  };

  public static readonly getWorkflowsWithSorting: any = {
    method: 'get',
    url: 'workflow/{appId}/{field}/{direction}'
  };

  public static readonly getWorkflows: any = {
    method: 'get',
    url: 'workflow',
    withAppIdInUrl: true
  };
  public static readonly getWorkflowWithSearch: any = {
    method: 'post',
    url: 'workflow/search/app',
    withAppIdInUrl: true
  };

  public static readonly getWorkflowById: any = {
    method: 'get',
    url: 'workflow/sid/{sid}',
    withAppIdInUrl: true
  };

  public static readonly saveWorkflow = {
    method: 'post',
    url: 'workflow/create',
    withAppIdInUrl: true
  };

  public static readonly updateWorkflow = {
    method: 'put',
    url: 'workflow'
  };

  public static readonly deleteWorkflow = {
    method: 'delete',
    url: 'workflow/{ids}',
    withAppIdInUrl: true
  };

  public static readonly getWorkflowActorById: any = {
    method: 'get',
    url: 'workflowactorsteps/sid/{sid}',
    withAppIdInUrl: true
  };

  public static readonly getWorkflowActionById: any = {
    method: 'get',
    url: 'workflowactionsteps/sid/{sid}',
    withAppIdInUrl: true
  };

  public static readonly getAllWorkflowActor: any = {
    method: 'get',
    url: 'workflowactorsteps/{workflowId}',
    withAppIdInUrl: true
  };

  public static readonly getAllWorkflowAction: any = {
    method: 'get',
    url: 'workflowactionsteps/{workflowId}',
    withAppIdInUrl: true
  };

  public static readonly updateWorkflowOrder = {
    method: 'put',
    url: 'workflow/batch',
    withAppIdInUrl: true
  };

  public static readonly pushCodetoGit = {
    method: 'post',
    url: 'git/{appId}/push'
  };

  public static readonly pushCodetoGitPolling = {
    method: 'get',
    url: 'generationlogs/gitpush/latestmodified/{generationLogId}',
    withAppIdInUrl: true
  };

  public static readonly pullCodeFromGit = {
    method: 'post',
    url: 'git/{appId}/pull'
  };
  public static readonly syncToGit = {
    method: 'post',
    url: 'git/{appId}/sync'
  };
  public static readonly getLoginMethod = {
    method: 'get',
    url: 'applogininfos/app/'
  };
  public static readonly saveLoginMethod = {
    method: 'post',
    url: 'applogininfos'
  };
  public static readonly updateLoginMethod = {
    method: 'put',
    url: 'applogininfos'
  };
  public static readonly getWorkflowMailById: any = {
    method: 'get',
    url: 'workflowmailinfos/stepid/{stepid}/{appid}'
  };
  public static readonly getCloudLogs: any = {
    method: 'get',
    url: 'cloudbuilds/logs/{cloudBuildId}'
  };

  public static readonly saveWorkflowMail = {
    method: 'post',
    url: 'workflowmailinfos'
  };

  public static readonly updateWorkflowMail = {
    method: 'put',
    url: 'workflowmailinfos'
  };

  public static readonly deleteWorkflowMail = {
    method: 'delete',
    url: 'workflowmailinfos/{sid}',
    withAppIdinUrl: true
  };
  public static readonly getQueriesListByTableId = {
    method: 'get',
    url: 'querybuilders/table/{tableId}',
    withAppIdInUrl: true
  };
  public static readonly saveQuery: any = {
    url: 'querybuilders',
    method: 'post'
  };
  public static readonly updateQuery: any = {
    url: 'querybuilders',
    method: 'put'
  };
  public static readonly getQuery: any = {
    url: 'querybuilders/sid/{sid}',
    method: 'get',
    withAppIdInUrl: true
  };
  public static readonly getQueryReferences: any = {
    url: 'querybuilders/query/{queryId}/{type}',
    method: 'get',
    withAppIdInUrl: true
  };
  public static readonly getAllQueriesByAppId: any = {
    url: 'querybuilders/allqueries',
    method: 'get',
    withAppIdInUrl: true
  };
  public static readonly getQueryByAppId: any = {
    url: 'querybuilders/sid/{sid}/{appId}',
    method: 'get'
  };

  public static readonly saveForeignKey: any = {
    url: 'foreignkey',
    method: 'post'
  };
  public static readonly updateForeignKey: any = {
    url: 'foreignkey',
    method: 'put'
  };
  public static readonly getForeignKey: any = {
    url: 'foreignkey/table/{orgId}/{appId}/{tableId}',
    method: 'get'
  };
  public static readonly deleteForeignKey: any = {
    url: 'foreignkey/{orgId}/{appId}/{foreignKeyId}',
    method: 'delete'
  };
  public static readonly getAllForeignKeys: any = {
    url: 'foreignkey/{orgId}/{appId}',
    method: 'get'
  };

  public static readonly updateCud: any = {
    url: 'cudconfigurations/update',
    method: 'put'
  };

  public static readonly createCud: any = {
    url: 'cudconfigurations/create',
    method: 'post'
  };

  public static readonly getCud: any = {
    url: 'cudconfigurations/table/{tableId}',
    method: 'get'
  };

  public static readonly deleteCud: any = {
    url: 'cudconfigurations/delete/table/{tableId}',
    method: 'delete'
  };

  public static readonly saveIndex: any = {
    url: 'tableindex',
    method: 'post'
  };
  public static readonly updateIndex: any = {
    url: 'tableindex',
    method: 'put'
  };
  public static readonly getIndex: any = {
    url: 'tableindex/table/{orgId}/{appId}/{tableId}',
    method: 'get'
  };
  public static readonly deleteIndex: any = {
    url: 'tableindex/{orgId}/{appId}/{indexId}',
    method: 'delete'
  };

  public static readonly getImpMailById: any = {
    method: 'get',
    url: 'mailinfos/getbyEntityId/{entityId}/{appId}'
  };

  public static readonly saveImpMail = {
    method: 'post',
    url: 'mailinfos'
  };

  public static readonly updateImpMail = {
    method: 'put',
    url: 'mailinfos'
  };

  public static readonly deleteImpMail = {
    method: 'delete',
    url: 'mailinfos/{ids}/{appId}'
  };

  public static readonly getFSToken = {
    method: 'get',
    url: 'appuserprivileges/fstoken/{appId}'
  };

  public static readonly applDMUpdateName = {
    method: 'put',
    url: 'applicationdatamodels/update/name'
  };

  public static readonly applDMUpdatefldType = {
    method: 'put',
    url: 'applicationdatamodels/update/fieldType'
  };

  public static readonly applDMUpdateFuncPK = {
    method: 'put',
    url: 'applicationdatamodels/update/functionalPrimaryKey'
  };

  public static readonly applDMUpdateParentTbl = {
    method: 'put',
    url: 'applicationdatamodels/update/parenttable/properties'
  };

  public static readonly applDMUpdateAwdVal = {
    method: 'put',
    url: 'applicationdatamodels/update/allowedValues'
  };

  public static readonly applDMUpdateLookup = {
    method: 'put',
    url: 'applicationdatamodels/update/lookup'
  };

  public static readonly applDMUpdateTblTyp = {
    method: 'put',
    url: 'applicationdatamodels/update/tableType'
  };

  public static readonly createImportTemplates = {
    method: 'post',
    url: 'importtemplates'
  };

  public static readonly getAllImportTemplates = {
    method: 'get',
    url: 'importtemplates/table/{tableId}'
  };

  public static readonly getImportTemplate = {
    method: 'get',
    url: 'importtemplates/sid/{sid}/{appid}'
  };

  public static readonly deleteImportTemplates = {
    method: 'delete',
    url: 'importtemplates/{ids}'
  };

  public static readonly updateImportTemplates = {
    method: 'put',
    url: 'importtemplates'
  };

  public static readonly applDMUpdateExprops = {
    method: 'put',
    url: 'applicationdatamodels/update/exportProperties'
  };

  public static readonly updateFieldsAndReference = {
    method: 'put',
    url: 'applicationdatamodels/update/fieldsAndReference'
  };

  public static readonly updateQueryType = {
    method: 'put',
    url: 'applicationdatamodels/update/queryViewType'
  };

  public static readonly updateQueryViewFilters = {
    method: 'put',
    url: 'applicationdatamodels/update/queryViewFilters'
  };

  public static readonly updateFields = {
    method: 'put',
    url: 'applicationdatamodels/updateFields'
  };

  public static readonly updateRuntimeConfig = {
    method: 'put',
    url: 'runtimeconfigurations/update'
  };

  public static readonly getRuntimeConfig = {
    method: 'get',
    url: 'runtimeconfigurations/getByTableId/{tableId}'
  };

  public static readonly createAppMetaInfos = {
    method: 'post',
    url: 'appmetainfos/'
  };
  public static readonly getAppMetaInfos = {
    method: 'get',
    url: 'appmetainfos/get',
    withAppIdInUrl: true
  };

  public static readonly getSharedDbs = {
    method: 'get',
    url: 'shareddbconfig/database/suiteid/'
  };

  public static readonly deleteAppMetaInfos = {
    method: 'delete',
    url: 'appmetainfos/{modelId}'
  };

  public static readonly getAppMetaInfoCount = {
    method: 'get',
    url: 'appmetainfos/count/{appId}'
  };

  public static readonly getAppMetaInfo = {
    method: 'post',
    url: 'appmetainfos/fetchDocuments',
    withAppIdInUrl: true
  };

  public static readonly getAppUserMetaInfoCount = {
    method: 'get',
    url: 'appusermetainfo/count/{orgId}'
  };

  public static readonly getAppUserMetaInfo = {
    method: 'post',
    url: 'appusermetainfo/fetchDocuments',
    withOrgIdInUrl: true
  };

  public static readonly updatePackageOrServiceName = {
    method: 'post',
    url: 'cloudbuilds/migration/servicename/'
  };

  public static readonly updateViewer = {
    method: 'post',
    url: 'viewers/updateUsers'
  };

  public static readonly deleteViewer = {
    method: 'post',
    url: 'viewers/removeUsers'
  };

  public static readonly updateDragDrop = {
    method: 'post',
    url: 'applicationdatamodels/update/dragdropnodes'
  };
  public static readonly getFstoken = {
    method: 'get',
    url: 'appuserprivileges/fstoken',
    withAppIdInUrl: true,
    responseType: 'text'
  };
  public static readonly getEnvironmentInfo = {
    method: 'get',
    url: 'environmentinfo'
  };

  public static readonly createReferences = {
    method: 'post',
    url: 'references/create/{appId}',
    showloading: true
  };
  public static readonly validateReferences = {
    method: 'post',
    url: 'references/validate/{appId}',
    showloading: true
  };

  public static readonly getReferences = {
    method: 'post',
    url: 'modelreferences/retrieve'
  };

  public static readonly getAllModelReferencesForMerge = {
    method: 'post',
    url: 'modelreferences/retrieve/all'
  };

  public static readonly getReferencesOfMemberApp = {
    method: 'post',
    url: 'modelreferences/retrieve/memberapp/references/{appId}'
  };
  public static readonly getModelReferencesAll = {
    method: 'post',
    url: 'modelreferences/retrieve/all'
  };

  public static readonly getAllReferences = {
    method: 'get',
    url: 'modelreferences/get/references/{modelId}'
  };

  public static readonly getSharedDBReferences = {
    method: 'get',
    url: 'modelreferences/retrieve/shareddb/references/{modelId}'
  };

  public static readonly getMemberAppReferences = {
    method: 'get',
    url: 'modelreferences/retrieve/memberapp/references/{appId}'
  };

  public static readonly getTargetMemberAppReferences = {
    method: 'get',
    url: 'modelreferences/retrieve/target/memberapp/references/{appId}/{suiteId}'
  };

  public static readonly getReferencesWithProperty = {
    method: 'get',
    url: 'modelreferences/get/references/{property}/{modelId}'
  };

  public static readonly getModelReferences = {
    method: 'get',
    url: 'modelreferences/get/references/modelid/{modelId}'
  };

  public static readonly getModelReferencesByProperty = {
    method: 'get',
    url: 'modelreferences/get/references/modelid/{modelId}/property/{propertyName}'
  };

  public static readonly getReferredModelReferencesByProperty = {
    method: 'get',
    url: 'modelreferences/get/references/referredmodelid/{modelId}/property/{propertyName}'
  };

  public static readonly getTblReferences = {
    method: 'get',
    url: 'modelreferences/get/references/app/tables/{appId}'
  };

  public static readonly getReferredTables = {
    method: 'get',
    url: 'modelreferences/get/tables/references/app/{appId}'
  };

  public static readonly getMandatoryParamReferences = {
    method: 'get',
    url: 'modelreferences/get/references/{property}/{referredModelId}/{definitionId}/{appId}'
  };

  public static readonly getReferenceMessageBundle = {
    method: 'get',
    url: 'messagebundles/REFERENCE'
  };

  public static readonly getPrevalidationMessageBundle = {
    method: 'get',
    url: 'messagebundles/PREVALIDATION'
  };

  public static readonly getPrevalidationsByAppId = {
    method: 'get',
    url: 'prevalidations/notification',
    withAppIdInUrl: true
  };

  public static readonly codeGeneration = {
    method: 'post',
    url: 'codegenerator/generate'
  };

  public static readonly pushUiLibraries = {
    method: 'post',
    url: 'codegenerator/pushuilibraries',
    withAppIdInUrl: true
  };

  public static readonly pushBeLibraries = {
    method: 'post',
    url: 'codegenerator/pushbelibraries',
    withAppIdInUrl: true
  };

  public static readonly getLastPublish = {
    method: 'get',
    url: 'generationlogs/lastpublish',
    withAppIdInUrl: true
  };

  public static readonly getAppTableID = {
    method: 'get',
    url: 'applicationdatamodels/appuser',
    withAppIdInUrl: true
  };

  public static readonly maintenance = {
    method: 'post',
    url: 'maintenance/setup'
  };

  public static readonly getTableOrder = {
    method: 'get',
    url: 'applicationdatamodels/mappinginfo',
    withAppIdInUrl: true
  };

  public static readonly createAppSuiteOrMem = {
    method: 'post',
    url: 'apps/createApp'
  };

  public static readonly getIndeApps = {
    method: 'post',
    url: 'apps/independentapps/datatable',
    withOrgIdInUrl: true
  };

  public static readonly getDBs = {
    method: 'get',
    url: 'shareddbconfig/database/suiteid/{suiteid}/transactionaldb/{transactionaldb}'
  };

  public static readonly getMemAppsBySuite = {
    method: 'get',
    url: 'apps/memberapps/{suiteid}'
  };

  public static readonly addAppToSuite = {
    method: 'post',
    url: 'apps/moveAppToSuite'
  };

  public static readonly removeAppFromSuite = {
    method: 'post',
    url: 'apps/moveAppFromSuite'
  };

  public static readonly getallApps = {
    method: 'get',
    url: 'apps/apps',
    withOrgIdInUrl: true
  };

  public static readonly databaseRename = {
    method: 'put',
    url: 'shareddbconfig/database/rename'
  };

  public static readonly createDB = {
    method: 'post',
    url: 'shareddbconfig'
  };

  public static readonly deleteDB = {
    method: 'delete',
    url: 'shareddbconfig/{ids}/{appid}'
  };

  public static readonly getLookupDefinitions = {
    method: 'get',
    url: 'lookupdefinitions/table/{tableId}'
  };
  public static readonly getLookupDefinitionById = {
    method: 'get',
    url: 'lookupdefinitions/sid/{lookupdefinitionId}/{appId}'
  };
  public static readonly saveLookupDefinitions = {
    method: 'post',
    url: 'lookupdefinitions'
  };
  public static readonly updateLookupDefinitions = {
    method: 'put',
    url: 'lookupdefinitions'
  };
  public static readonly deleteLookupDefinitions = {
    method: 'delete',
    url: 'lookupdefinitions/{lookupdefinitionId}'
  };

  public static readonly appsCount = {
    method: 'get',
    url: 'apps/apps/count',
    withOrgIdInUrl: true
  };

  public static readonly getAppGenStatus = {
    method: 'get',
    url: 'generationstatus/get/generationstatus/{appId}'
  };

  public static readonly getStandardListPages = {
    method: 'get',
    url: 'screens/standardpages'
  };

  public static readonly getDataforParameterMapping = {
    method: 'get',
    url: 'getdataforparametermapping/{pageId}/{listTableId}/{detailTableId}',
    withAppIdInUrl: true,
    withOrgIdInUrl: true
  };

  public static readonly getDeletedRecord = {
    method: 'get',
    url: 'applicationdatamodels/deleteRecord/sid/{sid}'
  };

  public static readonly importSqlSchema = {
    method: 'post',
    url: 'ai-datamodel/generate-model-from-file/{orgId}/{appId}'
  };

  public static readonly acceptAiDataModel = {
    method: 'post',
    url: 'ai-datamodel/acceptmodel/{orgId}/{appId}/{uploadId}'
  };

  public static readonly rejectAiDataModel = {
    method: 'delete',
    url: 'ai-datamodel/rejectmodel/{appId}/{uploadId}'
  };

  public static readonly deleteAiIndex = {
    method: 'delete',
    url: 'ai-datamodel/delete/index/{orgId}/{appId}/{uploadId}/{tableId}/{uniqueKeyId}'
  };

  public static readonly deleteAiForeignkey = {
    method: 'delete',
    url: 'ai-datamodel/delete/foreignKey/{orgId}/{appId}/{uploadId}/{tableId}/{foreignKeyId}'
  };

  public static readonly deleteAiDM = {
    method: 'post',
    url: 'ai-datamodel/batch',
    withAppIdInUrl: true
  };

  public static readonly renameAiDM = {
    method: 'put',
    url: 'ai-datamodel/update/name'
  };

  public static readonly dataTypAiDM = {
    method: 'put',
    url: 'ai-datamodel/update/fieldType'
  };

  public static readonly dragDropAiDM = {
    method: 'post',
    url: 'ai-datamodel/update/dragdropnodes'
  };

  public static readonly updateAiParentTable = {
    method: 'put',
    url: 'ai-datamodel/update/parenttable/properties'
  };

  public static readonly updateAiAllowedValues = {
    method: 'put',
    url: 'ai-datamodel/update/allowedValues'
  };

  public static readonly generateModelForTablePrompt = {
    method: 'post',
    url: 'ai-datamodel/generate-model-for-table-prompt'
  };

  public static readonly generateModelForFieldPrompt = {
    method: 'post',
    url: 'ai-datamodel/generate-model-for-field-prompt'
  };
  public static readonly getSearchableFields = {
    method: 'get',
    url: 'applicationdatamodels/searchable/{tableId}'
  };

  public static readonly generateDeltaSQL = {
    method: 'post',
    url: 'deltasql/generate'
  };

  public static readonly getSearchableIndexFields = {
    method: 'get',
    url: 'searchableindexfields/fields/tableId/{tableId}'
  };

  public static readonly getSearchableIndexForeignKeyFields = {
    method: 'get',
    url: 'searchableindexfields/foreignkeyfields/tableId/{tableId}'
  };

  public static readonly searchableIndexCudOperations = {
    method: 'post',
    url: 'searchableindexfields/cud/batch'
  };

  public static readonly getAllAndSearchableFields = {
    method: 'get',
    url: 'searchableindexfields/searchablefields/tableId/{tableId}'
  };

  public static readonly getForeignKeyAndReferenceFields = {
    method: 'get',
    url: 'searchableindexfields/searchableforeignkeyfields/tableId/{tableId}'
  };

  public static readonly getSearchableFieldsByTableId = {
    method: 'get',
    url: 'searchableindexfields/searchablefields/fields/all/{tableId}'
  };

  public static readonly getPageVariables = {
    method: 'get',
    url: 'pagevariables/getAll/{orgId}/{appId}/{pageSid}'
  };

  public static readonly savePageVariable = {
    method: 'post',
    url: 'pagevariables'
  };

  public static readonly updatePageVariable = {
    method: 'put',
    url: 'pagevariables'
  };

  public static readonly deletePageVariable = {
    method: 'delete',
    url: 'pagevariables/{orgId}/{appId}/{pageVariableSid}'
  };

  public static readonly getAllAppsFromSuite = {
    method: 'get',
    url: 'apps/getAppsFromSuite/{suiteid}'
  };

  public static readonly getTablesUsedInQueryViewActionConfig = {
    method: 'get',
    url: 'cudconfigurations/getTablesInQueryView/{orgId}/{appId}/{tableId}'
  };

  public static readonly getApplicationDataModelCount = {
    method: 'get',
    url: 'applicationdatamodels/count',
    withAppIdInUrl: true
  };

  public static readonly getApplicationDataModel = {
    method: 'get',
    url: 'applicationdatamodels/fetchDocuments',
    withAppIdInUrl: true
  };

  public static readonly getReservedKeywords = {
    method: 'get',
    url: 'reserved-keywords'
  };

  public static readonly createBranchOrTag = {
    method: 'post',
    url: 'apps/refs/create'
  };

  public static readonly updateDefaultBranch = {
    method: 'post',
    url: 'appuserprivileges/updatedefaultbranch'
  };

  public static readonly getDefaultBranches = {
    method: 'get',
    url: 'appuserprivileges/getdefaultbranch/{userId}/{orgId}'
  };

  // Branch management
  public static readonly fetchBranchInfo = {
    method: 'get',
    url: 'rest/v1/appmetainfos/fetchBranchInfo/{orgId}'
  };
  public static readonly getBranchesOrTags = {
    method: 'post',
    url: 'rest/v1/apps/{parentAppSid}/refs?suiteMode={suiteMode}'
  };
  public static readonly getBranchOrTagFilterOptions = {
    method: 'post',
    url: 'rest/v1/apps/{parentAppSid}/autosuggest'
  };

  public static readonly getLastUpdatedDetails = {
    method: 'get',
    url: 'rest/v1/branchchangelogs/{branchId}/lastupdatedon'
  };
  public static readonly updateComments = {
    method: 'put',
    url: 'rest/v1/apps/updatecomments'
  };
  public static readonly getMergeHistory = {
    method: 'post',
    url: 'rest/v1/mergehistorytrackers'
  };
  public static readonly getMergeHistoryById = {
    method: 'get',
    url: 'rest/v1/mergehistorytrackers/{mergeId}'
  };
  public static readonly getMergeHistoryFilterOptions = {
    method: 'post',
    url: 'rest/v1/mergehistorytrackers/autosuggest/{branchId}'
  };

  // View Changes API endpoints
  public static readonly getComponentChanges = {
    method: 'post',
    url: 'rest/v1/branchchangelogs/fetch/changelogs'
  };
  public static readonly getComponentChangesFilterOptions = {
    method: 'post',
    url: 'rest/v1/branchchangelogs/autosuggest/{branchId}'
  };
  public static readonly getComponentChangeDetails = {
    method: 'post',
    url: 'rest/v1/branchchangelogs/componentdetails'
  };
  // Merge Changes API endpoints
  public static readonly getBranchMergeChanges = {
    method: 'post',
    url: 'branchchangelogs/getchanges'
  };

  public static readonly getLastSuccessfulMerge = {
    method: 'post',
    url: 'branchchangelogs/lastsuccessfulmerge'
  };

  public static readonly getMergeAutoSelect = {
    method: 'post',
    url: 'branchchangelogs/getchanges/autoselect'
  };

  public static readonly checkMergeEligibility = {
    method: 'get',
    url: 'branchchangelogs/checkmergeeligibility/{branchId}'
  };

  public static readonly mergeBranch = {
    method: 'post',
    url: 'branchchangelogs/merge'
  };
  public static readonly cancelMergeHistoryTracker = {
    method: 'put',
    url: 'mergehistorytrackers/{mergeId}/cancel'
  };

  public static readonly deleteBranch = {
    method: 'delete',
    url: 'rest/v1/apps/{branchId}'
  };

  public static readonly deleteTag = {
    method: 'delete',
    url: 'rest/v1/apps/{tagId}'
  };

  // Query String APIs
  public static readonly getQueryStrings = {
    method: 'post',
    url: 'querystrings/datatable',
    withAppIdInUrl: true
  };

  public static readonly getQueryStringResolvedQuery = {
    method: 'post',
    url: 'querystrings/getresolvedquery'
  };

  public static readonly createQueryString = {
    method: 'post',
    url: 'querystrings',
    showErrorMsg: false
  };

  public static readonly updateQueryString = {
    method: 'put',
    url: 'querystrings',
    showErrorMsg: false
  };

  public static readonly deleteQueryString = {
    method: 'delete',
    url: 'querystrings/{sid}'
  };

  public static getQueryStringBySid = {
    method: 'get',
    url: 'querystrings/sid/{sid}',
    showloading: true
  };

  //get all generations(re) based on appid
  public static readonly getAllGenerations = {
    method: 'post',
    url: 're/wizard/datatable'
  };

  public static readonly createGeneration = {
    method: 'post',
    url: 're/wizard'
  };
  public static readonly updateGeneration = {
    method: 'put',
    url: 're/wizard'
  };

  //get all components based on generationId
  //componentType = PROCESS | USER_STORY
  public static readonly getAllComponentsByGenerationId = {
    method: 'get',
    url: 're/wizard/user-story-interim/{generationId}/{componentType}'
  };

  //componentType = PROCESS | USER_STORY
  public static readonly createComponent = {
    method: 'post',
    url: 're/wizard/user-story-interim'
  };

  public static readonly getAllModulesByGenerationId = {
    method: 'get',
    url: 're/module-interim/{generationId}'
  };

  public static readonly createModule = {
    method: 'post',
    url: 're/module-interim'
  };
  public static readonly updateModule = {
    method: 'put',
    url: 're/module-interim'
  };
  public static readonly deleteModule = {
    method: 'delete',
    url: 're/module-interim/{moduleId}'
  };
  //componentType = PROCESS | USER_STORY
  public static readonly updateComponent = {
    method: 'put',
    url: 're/wizard/user-story-interim'
  };
  //componentType = PROCESS | USER_STORY
  public static readonly deleteComponent = {
    method: 'delete',
    url: 're/wizard/user-story-interim/{componentId}'
  };
  public static readonly getAllLogs = {
    method: 'get',
    url: 're/wizard/{generationId}/completion-logs'
  };
  //Roles from interim table
  public static readonly updateRolesInterim = {
    method: 'put',
    url: 're/wizard/role'
  };
  public static readonly getAllRoles = {
    method: 'post',
    url: 're/wizard/role/{generationId}'
  };

  public static readonly deleteRoleInterim = {
    method: 'delete',
    url: 're/wizard/role/{roleId}'
  };
  public static readonly createNewRoleIntrim = {
    method: 'post',
    url: 're/wizard/role'
  };
  public static readonly getModernizedRolesData = {
    method: 'post',
    url: 'api/modernized-roles'
  };
  public static readonly getWizardRolesData = {
    method: 'get',
    url: 'v1/re/wizard/role/:wizardId'
  };
  public static readonly getRoleById = {
    method: 'get',
    url: 're/wizard/role/{roleId}'
  };
  //ACL Permissions from Interim table
  public static readonly getAllAclPermissions = {
    method: 'post',
    url: 're/wizard/aclpermission/{generationId}'
  };
  public static readonly createAclPermission = {
    method: 'post',
    url: 're/wizard/aclpermission'
  };
  public static readonly updateAclPermission = {
    method: 'put',
    url: 're/wizard/aclpermission'
  };
  public static readonly batchUpdateAclPermissions = {
    method: 'put',
    url: 're/wizard/aclpermission/batch'
  };
  public static readonly bulkCopyAclRoles = {
    method: 'put',
    url: 're/wizard/aclpermission/{generationId}/bulkcopy'
  };
  //navigate steps
  public static readonly navigateStep = {
    method: 'put',
    url: 're/wizard/{generationId}/steps/navigate'
  };
  //componentType = MODULE | PROCESS | USER_STORY
  public static readonly generateComponentByPrompt = {
    method: 'put',
    url: 're/wizard/{generationId}/steps/generate/{componentType}'
  };

  public static readonly getGenerationById = {
    method: 'get',
    url: 're/wizard/{generationId}'
  };

  public static readonly getProcessHierarchy = {
    method: 'get',
    url: 'user-stories-v2/{appId}/processes'
  };
  public static readonly getUserStoriesForProcess = {
    method: 'get',
    url: 'user-stories-v2/{appId}/processes/{processId}/user-stories'
  };
  public static readonly deleteUserStory = {
    method: 'delete',
    url: 'user-stories-v2/{userStoryId}'
  };
  public static readonly deleteProcess = {
    method: 'delete',
    url: 'user-stories-v2/{processId}'
  };
  public static readonly createUserStory = {
    method: 'post',
    url: 'user-stories-v2'
  };
  public static readonly createProcess = {
    method: 'post',
    url: 'user-stories-v2'
  };
  public static readonly updateUserStory = {
    method: 'put',
    url: 'user-stories-v2'
  };
  public static readonly updateProcess = {
    method: 'put',
    url: 'user-stories-v2'
  };
  public static readonly completeGeneration = {
    method: 'put',
    url: 're/wizard/{generationId}/complete-generation'
  };

  public static readonly retryFailedIngestedFiles = {
    method: 'put',
    url: 're/wizard/{generationId}/ingestion?ingestFailedFiles=true'
  };

  public static readonly companionAppCreate = {
    method: 'post',
    url: 'app/create',
    serviceType: 'companion',
    showSpinner: false
  };

  public static readonly sessions = {
    method: 'get',
    url: 'sessions?days=10&limit=50',
    serviceType: 'companion',
    showSpinner: false
  };

  public static readonly sessionMessages = {
    method: 'get',
    url: 'sessions/{sessionId}/messages/{limit}/{cursor}',
    serviceType: 'companion',
    showSpinner: false
  };

  public static readonly companionChatCreate = {
    method: 'post',
    url: 'chat/create',
    serviceType: 'companion',
    showSpinner: false
  };

  public static readonly companionChatResume = {
    method: 'post',
    url: 'chat/resume',
    serviceType: 'companion',
    showSpinner: false
  };

  public static readonly npmRegistry = {
    method: 'get',
    url: 'npm/registry'
  };

  //Screens from interim
  public static readonly getAllScreensInterim = {
    method: 'get',
    url: 're/screen-interim/{generationId}'
  };
  public static readonly getScreenInterim = {
    method: 'get',
    url: 're/screen-interim/page/{screenSid}'
  };
  public static readonly updateScreenInterim = {
    method: 'put',
    url: 're/screen-interim'
  };
  public static readonly updateScreenContentInterim = {
    method: 'put',
    url: 're/screen-interim/updatecontent'
  };
  public static readonly deleteScreenInterim = {
    method: 'delete',
    url: 're/screen-interim/{screenId}'
  };

  public static readonly getStandardPagesInterim = {
    method: 'get',
    url: 're/screen-interim/standardpages/{generationId}/{tableId}'
  };

  public static readonly getChildTablesInterim = {
    method: 'get',
    url: 're/screen-interim/childtables/{generationId}/{parentTableId}'
  };

  public static readonly toggleRaiModeForCurrentUser = {
    method: 'put',
    url: 'appuserprivileges/current-user/toggle-rai-mode'
  };

  public static readonly getFieldForPagesInterim = {
    method: 'get',
    url: 're/screen-interim/configuredfields/'
  };

  public static readonly getWorkflowInterims = {
    method: 'get',
    url: 're/wizard/workflow/list/{generationId}'
  };

  public static readonly getWorkflowInterimById = {
    method: 'get',
    url: 're/wizard/workflow/{workflowId}'
  };

  public static readonly deleteWorkflowInterim = {
    method: 'delete',
    url: 're/wizard/workflow/{workflowId}'
  };

  public static readonly getAIApplicationDataModelFields = {
    method: 'get',
    url: 'ai-datamodel/fields/all/{tableId}'
  };

  public static readonly getDataModelsByGenerationId = {
    method: 'post',
    url: 'ai-datamodel/all/{appId}/{generationId}'
  };

  public static readonly codeIDE = CODE_EDITOR_API_CONSTANTS;
  public static readonly companion = COMPANION_API_CONSTANTS;

  public static readonly blueprint = PROJECT_CHARTER_API_CONSTANTS;
  public static readonly environmentAvailability = ENVIRONMENT_AVAILABILITY_API_CONSTANTS;

  public static readonly preview = PREVIEW_API_CONSTANTS;
}
